import { RouteComponentProps, Router } from "@reach/router";
import React, { useState, useCallback } from "react";
import { useTabbedNav } from "../utils/hooks/useNav";
import { Page } from "../Components/Page";
import MetaLiftCreate from "./MetaLiftCreate";
import { useCompanyInfo } from "../redux/company";
import MetaLiftTable from "./MetaLiftTable";

const enum PageTab {
  CREATE = "create",
  PUBLISHED = "published",
}

const NAVS = [
  { label: "Create", key: PageTab.CREATE },
  { label: "Published", key: PageTab.PUBLISHED },
];

const MetaLiftStudy = React.memo(({ navigate }: RouteComponentProps) => {
  const { tab, goToTab } = useTabbedNav({
    navigate,
    baseURL: "meta-lift-study",
    defaultKey: PageTab.CREATE,
    navs: NAVS.map(nav => nav.key, NAVS),
  });

  const { cid } = useCompanyInfo();

  const [tableRefreshKey, setTableRefreshKey] = useState(0);

  const handleNavigateToPublished = useCallback(() => {
    setTableRefreshKey(prev => prev + 1);

    goToTab(PageTab.PUBLISHED);
  }, [goToTab]);

  return (
    <Page
      app2Redesign
      title="Meta Lift Study"
      pageType="Meta Lift Study"
      navs={NAVS}
      selectedNav={tab}
      onNav={goToTab}
    >
      <Router className="fullPageRouter">
        <MetaLiftCreate
          company={cid}
          path={PageTab.CREATE}
          onNavigateToPublished={handleNavigateToPublished}
        />
        <MetaLiftTable
          company={cid}
          mode="published"
          path={PageTab.PUBLISHED}
          refreshKey={tableRefreshKey}
        />
      </Router>
    </Page>
  );
});
export default MetaLiftStudy;
